import { CommonModule } from '@angular/common';
import { Component, inject } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { Store } from '@ngrx/store';
import { combineLatest } from 'rxjs';
import { surveyAction } from '../../features';
import {
  EvaluateSurveyDisplay,
  evaluateSurveyFeature,
} from '../../features/evaluate-survey/evaluate-survey.reducer';
import { surveyFeature } from '../../features/survey/survey.selectors';
import { EvaluateResponseComponent } from '../evaluate-response/evaluate-response.component';
import { SurveyPageLogoComponent } from '../survey-page-logo/survey-page-logo.component';

@Component({
  selector: 'lib-evaluate-submit',
  standalone: true,
  imports: [
    CommonModule,
    SurveyPageLogoComponent,
    MatIconModule,
    MatButtonModule,
    EvaluateResponseComponent,
  ],
  templateUrl: './evaluate-submit.component.html',
  styleUrls: ['./evaluate-submit.component.scss'],
})
export class EvaluateSubmitComponent {
  private store = inject(Store);

  readonly Display = EvaluateSurveyDisplay;

  readonly vm$ = combineLatest({
    template: this.store.select(surveyFeature.selectSurveyTemplate),
    display: this.store.select(evaluateSurveyFeature.selectDisplay),
  });

  previousPage() {
    this.store.dispatch(surveyAction.previousPage());
  }
}
